export const TOOLBAR_TAG_NAME = "toolbar" as const;

export const TOOLBAR_SECTION_TAG_NAME = "toolbar-section" as const;

export const TOOLBAR_ALIGNS = ["start", "center", "end", "between"] as const;
